module.exports = __webpack_public_path__ + "img/IMG_0894.5a7b30de.png";